import { environment } from '../../../environments/environment';

export type AppScope = 'admin' | 'organization';

export function resolveAppScope(rawScope: string | null | undefined): AppScope {
  if ((rawScope ?? '').trim().toLowerCase() === 'organization') {
    return 'organization';
  }

  return 'admin';
}

export function currentAppScope(): AppScope {
  return resolveAppScope(environment.shellScope);
}

